import { render } from "./Billing.vue?vue&type=template&id=1982238a&scoped=true&ts=true"
import script from "./Billing.vue?vue&type=script&lang=ts"
export * from "./Billing.vue?vue&type=script&lang=ts"

import "./Billing.vue?vue&type=style&index=0&id=1982238a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1982238a"]])

export default __exports__